module.exports = __webpack_public_path__ + "assets/gsap.67c485b8.svg";